import React, { useState, useEffect } from 'react';
import { navigate } from "@reach/router"
import { useMappedState, useDispatch } from 'redux-react-hook';
import { Tabs, Result, Icon, Row, Col, Button, Skeleton } from 'antd';
import { getMyaccount } from './../API';
import { flexCenterRight } from './../theme';

const { TabPane } = Tabs;

function MyDrive() {
  const session = useMappedState(state => state.session);
  const dispatch = useDispatch();
  const me = useMappedState(state => state.me);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const response = await getMyaccount(session.authToken);
      dispatch({type: "INIT_ME", payload: response.data.me});
      setLoading(false);
    }
    fetchData();
  // eslint-disable-next-line
  }, []);

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    (
      <Tabs type="card">
        <TabPane tab={
          <span><Icon type="google" />My Drive</span>
        } key="mydrive">
        <div>
          {me.driveFolderID ? (
            <div>
              <Row>
                <Col span={12} />
                <Col span={12}>
                  <div style={flexCenterRight}>
                    <Button type="primary" onClick={() => {
                      window.open(`https://drive.google.com/drive/folders/${me.driveFolderID}`,'_blank');
                    }}><Icon type="link" /> Open My Folder</Button>
                  </div>
                </Col>
              </Row>
              <br />
              <iframe 
                title="Google Drive iFrame" 
                src={`https://drive.google.com/embeddedfolderview?id=${me.driveFolderID}#grid`} 
                style={{width: '100%', height: '600px', border: 0}}
              />
            </div>
          ):(
            <Result
              status="warning"
              title="Google drive folder has not been setup yet, please fill it in my account page."
              extra={
                <Button type="primary" key="console" onClick={() => {
                  navigate("/myaccount") 
                }}>
                  Go To My Account
                </Button>
              }
            />
          )}
        </div>
        </TabPane>
        <TabPane tab={
          <span><Icon type="google" />Link Global Drive</span>
        } key="lgdrive">
          <div>
            <Row>
              <Col span={12} />
              <Col span={12}>
                <div style={flexCenterRight}>
                  <Button type="primary" onClick={() => {
                    window.open(`https://drive.google.com/drive/folders/${process.env.REACT_APP_LG_DRIVE}`,'_blank');
                  }}><Icon type="link" /> Open Link Global Folder</Button>
                </div>
              </Col>
            </Row>
            <br />
            <iframe 
              title="Google Drive iFrame" 
              src={`https://drive.google.com/embeddedfolderview?id=${process.env.REACT_APP_LG_DRIVE}#grid`} 
              style={{width: '100%', height: '600px', border: 0}}
            />
          </div>
        </TabPane>
      </Tabs>
    )
  );
}

export default MyDrive;